/*
 * ATELIER — temporary one-client configurator (Serie 1 + classy case)
 * ─────────────────────────────────────────────────────────────────────
 * Who may open /configurator/atelier and see its tile on the model picker.
 * Used by: src/router/index.js (route guard, meta.requiresAtelier)
 *          src/components/ConfiguratorSelect.vue (Atelier tile)
 *
 * UIDs: Firebase console → Authentication → Users → "User UID".
 * Use the PRODUCTION project's UID — dev and prod give the same person
 * different UIDs. Add your dev UID to test locally.
 *
 * Remove after ~30 days: delete this file, ConfiguratorMgdAtelier.vue,
 * the Atelier route + its check in the router, and the tile in
 * ConfiguratorSelect.vue (all marked "ATELIER").
 *
 * This only hides the page inside the app — it is not server-side security.
 */

export const ATELIER_UIDS = [
  "96F2vwsJprVn09CJpLeA03L35dE3", // Atelier client — until 2026-11-22
];

export function isAtelierUser(user) {
  return !!user && ATELIER_UIDS.includes(user.uid);
}
